export interface TimeSeriesItemDetail {
    name: string;
    numberOfEntries: number;
    startDate: Date;
    endDate: Date;
}